import React from "react";
// optional styling

const LoaderComponent = ({ message = "Loading..." }) => {
  return (
    <div className="loader-overlay">
      <div className="loader-box">
        <div className="spinner" />
        <p className="loader-text">{message}</p>
      </div>
    </div>
  );
};

export default LoaderComponent;
